export default "__VITE_ASSET__BSmMDYgT__"